import { make } from 'vuex-pathify'
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker'
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker'
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker'

const remoteEntityName = 'orgs.orgs'

const state = {
  ...makeTableCommonState()
}

const getters = {
  ...makeTableCommonGetters({ remoteEntityName }),

  pageTitle: () => 'Orgs',
  remoteEntityName: () => remoteEntityName,

  controlledActions: () => {
    return { // 0 if anyone can. -1 if disabled (i.e., no one can); 'creator' -- if only user with id same as created_by_user_id
      create: 0,
      fetch: 0,
      update: 0,
      delete: 0,
      downloadList: -1,
      uploadList: -1
    }
  },

  columns: (state, getters, rootState) => {
    return [
      { name: 'del', field: 'id', style: 'width: 30px', hideWhenCreating: true },
      // { name: 'view', field: 'id', hideWhenCreating: true },
      // { name: 'selector', field: 'id', hideWhenCreating: true },
      { name: 'row_menu', type: 'row_menu', hideWhenCreating: true },
      { name: 'id', label: 'ID', style: 'width:50px;', field: 'id', align: 'right', hideWhenCreating: true, isNumeric: true },
      { name: 'native_id', disguised: true, style: 'width:80px', label: 'Native ID', field: 'native_id', align: 'right' },
      { name: 'name', disguised: true, label: 'Name', field: 'name', inlineEdit: true, align: 'left', required: true, uiFilterTypes: ['selectedValuesFilter'] },
      { name: 'parent_id', editable: true, disguised: true, label: 'Parent', field: 'parent_id', required: true, references: 'orgs.orgs', align: 'left' },
      { name: 'org_level_id', label: 'Org level', field: 'org_level_id', references: 'orgs.org_levels_org_specific_labels', align: 'left', uiFilterTypes: ['selectedValuesFilter'] }
    ]
  },

  controllerDefaultParams: (state, getters, rootState) => ({
    fetch: { tenant_id: (rootState.authorizedUser.currentTenantObject || {}).id }
  })
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  ...makeTableCommonActions()
}

export default { state, actions, mutations, getters, namespaced }
